import { GameObject } from './GameObject'

export abstract class Component {
  private _exist = true
  get exist() { return this._exist }
  gameObject!: GameObject
  private _enabled = true

  get enabled() { return this._enabled }
  set enabled(value: boolean) {
    if (this._enabled === value) return
    this._enabled = value
    this.onActiveStateChanged()
  }
  private _started = false
  get started() { return this._started }

  get scene() { return this.gameObject.scene }
  get engine() { return this.gameObject.engine }
  get transform() { return this.gameObject.transform }
  get renderer() { return this.gameObject.renderer }
  constructor(gameObject: GameObject) {
    this.gameObject = gameObject
  }
  loadStart() {
    this.start()
    this._started = true
  }
  setup(_data: any) { }
  start() { }
  fixedUpdate(_dt: number) { }
  update(_dt: number) { }
  render(_dt: number) { }
  onMove() { }
  onAfterMove() { }
  onDestroy() { }
  onComponentAdded(_component: Component) { }
  onActiveStateChanged() { }
  remove() { this.gameObject.removeComponent(this) }
  setExist(value: boolean) { this._exist = value }
}
